import {
  DataGrid,
} from '@/components/DataGrid';
import { useFetchList } from './service';
import { resourcePluralTitle } from './settings';
import HeaderLayout from '@/components/Layout/HeaderLayout';
import ContainerLayout from '@/components/Layout/ContainerLayout';
import { Box, Button, ButtonGroup, Flex, FocusLock, FormControl, FormLabel, Grid, IconButton, Input, InputProps, Popover, PopoverArrow, PopoverCloseButton, PopoverContent, PopoverTrigger, Stack, Text, useDisclosure, useToast } from '@chakra-ui/react';
import ReactSelect from "react-select";
import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { ForwardedRef, forwardRef, useRef, useState } from 'react';
import { EditIcon, SearchIcon } from '@chakra-ui/icons';
import { Paper } from '@/components/Paper';
import { IoBusiness } from "react-icons/io5";
import { UseLoading } from '@/hooks/useLoading';
import { useBranch } from '@/hooks/useBranch';

export type FilialAcesso = {
  dataliberacao: string,
  filial: string,
  id: number | string,
  nomefilial: string,
  usuario: string | number,
  usuarioliberacao: string | number
}

export function PermissaoFiliaisList() {
  const toast = useToast();
  const {
    startLoading,
    stopLoading,
    isLoading
  } = UseLoading()
  const [usuario, setUsuario] = useState<string>();
  const [usuarioSelecionado, setUsuarioSelecionado] = useState<{ usuario: string, id: number }>();

  const [filiais, setFiliais] = useState<FilialAcesso[]>();


  const { data: listUsuario } = useQuery({
    queryKey: [usuario, 'usuario'],
    queryFn: () => api.get(`usuario/geral/filtro?page=${0}&size=${4}`, {
      params: {
        nome: usuario
      }
    }),
    select: (data) => {
      return data?.data?.paginacao?.filter((usuario: any) => usuarioSelecionado?.id != usuario?.id)?.map(
        (usuario: any) => ({
          label: usuario?.nome,
          value: usuario?.id
        })
      )
    }
  });

  const getFiliaisCadastro = async () => {
    try {
      const req = await api.get<FilialAcesso[]>('acesso/filial/cadastro/' + usuarioSelecionado?.id);
      const res = req.data;
      setFiliais(res);
    } catch (error) {
      toast({
        description: 'Erro',
        position: 'top'
      });
      return;
    } finally {
      return;
    }
  }

  const searchFiliaisUsuarios = async () => {
    if (!usuarioSelecionado) {
      toast({
        description: 'Sem usuário',
        position: 'top'
      });
      return;
    }
    await getFiliaisCadastro();
  };

  const onSubmitAddFilial = async (filialAcesso: any) => {
    startLoading()
    try {
      const req = await api.post(`acesso/filial`, {
        ...filialAcesso, ativo: true
      });
      const res = req.data;
      toast({
        description: 'Adicionado a Filial',
        status: 'success',
        title: 'Sucesso!'
      });
      await getFiliaisCadastro()
    } catch (error: any) {
      toast({
        description: JSON.stringify(error?.response?.data?.mensagem),
        status: 'error',
        title: 'Erro!'
      })
    } finally {
      stopLoading()
    }
  }

  const onSubmitRemFilial = async (filialAcesso: any) => {
    startLoading()
    try {
      const req = await api.post(`acesso/filial`, {
        ...filialAcesso, ativo: false
      });
      const res = req.data;
      toast({
        description: 'Adicionado a Filial',
        status: 'success',
        title: 'Sucesso!'
      })
      await getFiliaisCadastro()
    } catch (error: any) {
      toast({
        description: JSON.stringify(error?.response?.data?.mensagem || "Erro ao realizar operação"),
        status: 'error',
        title: 'Erro!'
      })
    } finally {
      stopLoading()
    }
  }

  return (
    <ContainerLayout>
      <HeaderLayout
        breadcrumbActived
        title={resourcePluralTitle}
      />
      <DataGrid query={useFetchList}>

        <Box flex={1} maxWidth={{ lg: 'container.lg', xl: 'container.xl' }} flexGrow={1} p={2} position={'relative'}>
          <Flex transition={'ease-in 150ms all'} gap={2}>
            <Grid bg={'#fff'} flex={1} mb={5} maxWidth={{ lg: 'container.lg', xl: 'container.xl' }} borderRadius={'12px'} w={'100%'} rowGap={4} p={4}>
              <p style={{ fontWeight: 600 }}>Procure o usuário:</p>
              <Flex gap={4}>
                <ReactSelect
                  placeholder={'Pesquise o nome do usuário...'}
                  options={usuarioSelecionado ? listUsuario?.concat({ label: usuarioSelecionado.usuario, value: usuarioSelecionado?.id }) : listUsuario}
                  //@ts-ignore
                  onChange={(text) => setUsuarioSelecionado({ usuario: text?.label, id: text?.value })}
                  onInputChange={(res) => { setUsuario(res); }}
                  styles={{
                    container: (base, state) => ({
                      ...base,
                      flexGrow: 1
                    })
                  }}
                />
                <Button colorScheme='blue' onClick={searchFiliaisUsuarios}>
                  <SearchIcon />
                </Button>
              </Flex>
            </Grid>
          </Flex>
          <Grid gridTemplateColumns={{ lg: 'repeat(3, 1fr)', sm: 'repeat(2, 1fr)' }} gap={2} py={2}>
            {
              filiais?.map(
                (filial: any) => <Paper bg={'#fff'} shadow={'sm'} rounded={'md'} p={2} border={'1px solid #cccccc96'}>
                  <Flex flexDir={'column'} gap={1}>
                    <Flex justifyContent={'space-between'} alignItems={'center'} mb={1} borderBottom={'1px solid #dcdddd96'} py={1}>
                      <Text fontWeight={600} fontSize={'1.1rem'}>#{filial?.idfilial} - {filial?.nomefantasia}</Text>
                      <Flex gap={1}>

                        <PopoverForm />
                        <Flex justifyContent={'center'} rounded='md' alignItems={'center'} p={1.5} h={'full'} border={'1px solid #ccc'}>
                          <IoBusiness />
                        </Flex>
                      </Flex>
                    </Flex>
                    <Button w={'full'} colorScheme='facebook' variant={'outline'} shadow={'sm'} onClick={filial.ativo ? () => onSubmitRemFilial(filial) : () => onSubmitAddFilial(filial)}>
                      {filial.ativo ? '- remover' : '+ adicionar'}
                    </Button>
                  </Flex>
                </Paper>
              )
            }
          </Grid>
        </Box>
      </DataGrid>
    </ContainerLayout>
  );
}


const TextInput = forwardRef((props: InputProps & { label: string }, ref) => {
  return (
    <FormControl>
      <FormLabel htmlFor={props.id}>{props.label}</FormLabel>
      <Input ref={ref} id={props.id} {...props} />
    </FormControl>
  )
})


const Form = ({ firstFieldRef, onCancel }: { onCancel: VoidFunction, firstFieldRef: ForwardedRef<InputProps & { label: string }> }) => {

  const { filial } = useBranch();
  const toast = useToast()

  const [logo, setLogo] = useState<string | ArrayBuffer>(filial?.logo || '');
  const { isLoading, startLoading, stopLoading } = UseLoading()

  async function onSubmit() {
    startLoading()
    if (filial?.logo == logo) return;
    await api.put('filial/geral/' + filial?.id, { ...filial, logo })
      .then(res => toast({
        title: 'Atualizado com sucesso!',
      }))
      .catch(err => toast({
        title: 'Erro ao atualizar!',
        description: JSON.stringify(err?.response?.data?.mensagem, null, 2)
      }))
      .finally(
        stopLoading
      )
  }

  const convertToBase64 = (file: File) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = () => {
      setLogo(reader.result || '')
    }
  }

  return (
    <Stack spacing={4}>
      <TextInput
        label='Logo filial'
        id='branch-logo'
        onChange={(e) => {
          {/* @ts-ignore */ }
          convertToBase64(e?.target?.files?.[0])
        }}
        ref={firstFieldRef}
        type='file'
      // defaultValue={filial?.logo}
      />
      <ButtonGroup display='flex' justifyContent='flex-end'>
        <Button variant='outline' onClick={onCancel}>
          Cancel
        </Button>
        <Button isDisabled={isLoading} onClick={onSubmit} colorScheme='teal'>
          Save
        </Button>
      </ButtonGroup>
    </Stack>
  )
}

const PopoverForm = () => {
  const { onOpen, onClose, isOpen } = useDisclosure()
  const firstFieldRef = useRef(null)

  return (
    <>
      <Popover
        isOpen={isOpen}
        initialFocusRef={firstFieldRef}
        onOpen={onOpen}
        onClose={onClose}
        placement='right'
        closeOnBlur={false}
      >
        <PopoverTrigger>
          <IconButton aria-label='settings-branch' bg={'transparent'} size='sm' icon={<EditIcon />} />
        </PopoverTrigger>
        <PopoverContent p={5}>
          {/*@ts-ignore*/}
          <FocusLock returnFocus persistentFocus={false}>
            <PopoverArrow />
            <PopoverCloseButton />
            <Form firstFieldRef={firstFieldRef} onCancel={onClose} />
          </FocusLock>
        </PopoverContent>
      </Popover>
    </>
  )
}